module.exports = __webpack_public_path__ + "img/app_code.d9d659a3.png";